import { useEffect } from 'react'
import ScanPage from './ScanPage'
import { setHomeScreenTitle } from '../utils/homeScreenApp'

// Scan Station: the Scan page on its own, full screen, for the iPad at the
// packing table. App.tsx renders it without the Hub header or menu. The scan
// logic is the Scan page's, so both always behave the same.
export default function StationPage() {
  // Name the tab and the Home Screen icon "Scan Station".
  useEffect(() => {
    const previousTitle = document.title
    document.title = 'Scan Station'
    setHomeScreenTitle('Scan Station')
    return () => {
      document.title = previousTitle
      setHomeScreenTitle("Poppin' Hub")
    }
  }, [])

  // Keep the iPad screen on while the station is open. The lock drops when
  // the app is hidden, so it's asked for again each time it comes back.
  useEffect(() => {
    type WakeLock = { release: () => Promise<void> }
    const nav = navigator as Navigator & {
      wakeLock?: { request: (type: 'screen') => Promise<WakeLock> }
    }
    if (!nav.wakeLock) return
    let lock: WakeLock | null = null
    let stopped = false
    const request = async () => {
      if (stopped || document.visibilityState !== 'visible') return
      try {
        lock = await nav.wakeLock!.request('screen')
      } catch {
        // Not allowed right now (low battery, settings); the screen just
        // follows the iPad's Auto-Lock as before.
      }
    }
    void request()
    document.addEventListener('visibilitychange', request)
    return () => {
      stopped = true
      document.removeEventListener('visibilitychange', request)
      void lock?.release().catch(() => {})
    }
  }, [])

  return <ScanPage station />
}
